import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';

const FormWaring = ({ warningText }) => {
    return (
        warningText?.value ? <div className={styles.formWarning}>{warningText.value}</div> : ''
    );
};

FormWaring.propTypes = {
    warningText: PropTypes.object,
};

export default errorBoundary(FormWaring);
